export enum API {
  LOGIN = '/login',
  LOGIN_2FA = '/verify-2fa',
  RESEND_2FA_CODE = '/resend-2fa-code',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
  REGISTRATION_STEP_ONE = '/register-step-one',
  REGISTRATION_STEP_TWO = '/register-step-two',
  REGISTRATION_STEP_THREE = '/register-step-three',
}
